<template>
  <svg
    t="1648629289851"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="1417"
    :width="width"
    :height="height"
  >
    <path
      d="M945.96 478.06L814.09 346.19c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25L857.4 480H544V166.6l88.56 88.56c6.25 6.25 14.44 9.38 22.62 9.38s16.38-3.12 22.62-9.38c12.5-12.5 12.5-32.75 0-45.25L545.94 78.04c-18.69-18.72-49.19-18.72-67.88 0L346.19 209.91c-12.5 12.5-12.5 32.75 0 45.25s32.75 12.5 45.25 0L480 166.6V480H166.6l88.56-88.56c12.5-12.5 12.5-32.75 0-45.25s-32.75-12.5-45.25 0L78.04 478.06c-18.72 18.69-18.72 49.19 0 67.88l131.88 131.88c12.5 12.5 32.75 12.5 45.25 0 6.25-6.25 9.38-14.44 9.38-22.62s-3.12-16.38-9.38-22.62L166.6 544H480v313.4l-88.56-88.56c-12.5-12.5-32.75-12.5-45.25 0s-12.5 32.75 0 45.25l131.88 131.88c18.69 18.72 49.19 18.72 67.88 0l131.88-131.88c12.5-12.5 12.5-32.75 0-45.25-6.25-6.25-14.44-9.38-22.62-9.38s-16.38 3.12-22.62 9.38L544 857.4V544h313.4l-88.56 88.56c-6.25 6.25-9.38 14.44-9.38 22.62s3.12 16.38 9.38 22.62c12.5 12.5 32.75 12.5 45.25 0l131.88-131.88c18.71-18.67 18.71-49.17-0.01-67.86z"
      p-id="1418"
      :fill="fill"
    ></path>
  </svg>
</template>

<script>
export default {
  props: {
    width: { default: '100%' },
    height: { default: '100%' },
    fill: { default: '#606266' }
  }
}
</script>
